<template>
  <div class="py-3">
    <CardWithCloseButton @onClose="$emit('onClose')">
      <div class="px-5 py-3">
        <div class="flex justify-between items-center">
          <p class="text-sm font-bold text-greenPrimary">Detail Scene</p>
          <SearchInput id="detailscene" @input="search" />
        </div>

        <div class="overflow-x-auto relative rounded-lg pt-3" v-if="!detailScene.loading">
          <table class="w-full text-sm text-left text-gray-500 mb-3">
            <thead>
              <tr class="bg-gray-200">
                <th scope="row" class="py-3 px-3 text-center border border-gray-300">
                  #
                </th>
                <th scope="row" class="py-3 px-3 border border-gray-300 text-center">
                  Feature ID
                </th>
                <th scope="row" class="py-3 px-3 text-center border border-gray-300">
                  Kode Petak
                </th>
                <th scope="row" class="py-3 px-3 text-center border border-gray-300">
                  Scene ID
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="bg-white text-center"
                v-for="(item, index) in detailScene.rows"
                :key="index"
              >
                <td class="border border-gray-300" valign="top">
                  {{ (page - 1) * limit + (index + 1) }}
                </td>
                <td class="py-2 px-3 border border-gray-300" valign="top">
                  {{ item.scene_id }}
                </td>
                <td class="py-2 px-3 border border-gray-300" valign="top">
                  <!-- {{ item.kode_petak }} -->
                  <div class="flex flex-wrap gap-1 max-h-[35vh] overflow-y-auto">
                    <div class="" v-for="kodepetak in item.kode_petak" :key="kodepetak">
                      {{
                        item.kode_petak[item.kode_petak.length - 1] === kodepetak
                          ? kodepetak
                          : `${kodepetak},`
                      }}
                    </div>
                  </div>
                </td>
                <td class="py-2 px-3 border border-gray-300" valign="top">
                  <!-- {{ item.scene_id }} -->
                  <div class="flex flex-wrap gap-1 max-h-[35vh] overflow-y-auto">
                    <div class="" v-for="featureid in item.feature_id" :key="featureid">
                      {{
                        item.feature_id[item.feature_id.length - 1] === featureid
                          ? featureid
                          : `${featureid},`
                      }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <PaginationComponent
            v-model:length="length"
            v-model:size="limit"
            v-model:page="page"
            @onSelectChange="changePage"
          />
        </div>

        <LoadingLottie v-if="detailScene.loading" />
      </div>
    </CardWithCloseButton>
  </div>
</template>
<script>
import CardWithCloseButton from "@/components/CardWithCloseButton.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import SearchInput from "@/components/SearchInput.vue";
import { useDashboardStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";

export default {
  components: {
    CardWithCloseButton,
    PaginationComponent,
    LoadingLottie,
    SearchInput,
  },
  setup() {
    const dashboardStore = useDashboardStore();
    const { detailScene } = storeToRefs(dashboardStore);

    const limit = ref(25);
    const offset = ref(0);
    const length = ref(0);
    const page = ref(1);
    const q = ref(null);

    const getDetail = async () => {
      await dashboardStore.getDetailScene({});
      length.value = detailScene.value.count;
    };

    onMounted(() => {
      getDetail();
    });

    const changePage = async (value) => {
      page.value = value;
      offset.value = (page.value - 1) * limit.value;
      let dataparams = { offset: offset.value };

      if (q.value != null || q.value != "") {
        dataparams = { ...dataparams, q: q.value };
      }
      await dashboardStore.getDetailScene(dataparams);
      length.value = detailScene.value.count;
    };

    const search = async (event) => {
      offset.value = 0;
      page.value = 1;
      q.value = event.target.value;

      await dashboardStore.getDetailScene({
        offset: offset.value,
        q: event.target.value,
      });
      length.value = detailScene.value.count;
    };

    return {
      detailScene,
      limit,
      page,
      length,
      changePage,
      search,
    };
  },
};
</script>
<style></style>
